// FearGreedWidget/FearGreedCache.js
// Normal Cache — CacheBase2 with rk-array, singleton export (Engine Pattern rk=f03ae8b6).
// Holds the raw 31-day history as-is, keyed on each item's rk (timestamp string).
// No custom overrides needed — base getAll/addOrUpdate/get(rk) cover everything.
import CacheBase2 from '../../../services/engines/CacheBase2';

const _name = 'FearGreedCache';

class FearGreedCache extends CacheBase2 {
    initialize() {
        this._name = _name;
    }
}

const fearGreedCache = new FearGreedCache();
export default fearGreedCache;
